<template>
  <div class="animated fadeIn" v-if="pageLoaded">
    <b-card style="border: 0" class="mt-0 mb-0">
      <b-card
        v-if="
          role == 'university' &&
          (status == 'نیاز به تکمیل / اصلاح' || status == 'پیش نویس') &&
          adminMessage
        "
        header-bg-variant="danger"
        header-text-variant="white"
        header="اصلاحات مورد نیاز"
        style="border: 0"
        class="shadow p-3 mb-5 bg-white rounded mt-0"
        >{{ adminMessage }}</b-card
      >
      <b-card
        v-if="role == 'university' && status == 'پذیرش اولیه' && adminMessage"
        header-bg-variant="danger"
        header-text-variant="white"
        header="راهنمای تکمیل قرارداد"
        style="border: 0"
        class="shadow p-3 mb-5 bg-white rounded mt-0"
        >{{ adminMessage }}</b-card
      >
      <b-card
        v-if="
          (role == 'university' || role == 'admin') && status == 'رد شده است'
        "
        header-bg-variant="danger"
        header-text-variant="white"
        header="دلایل رد"
        style="border: 0"
        class="shadow p-3 mb-5 bg-white rounded mt-0"
      >
        <ul>
          <li v-for="message in rejections" :key="message">- {{ message }}</li>
        </ul>
        <br />
      </b-card>
      <h3>کد درخواست طرح کلان: {{ requestsCode }}</h3>
      <h4 class="text-dark">وضعیت درخواست طرح کلان: {{ status }}</h4>
      <hr />
      <b-button
        style="float: left"
        v-if="tabIndex == 0"
        variant="primary"
        @click="saveDocx('doc')"
      >
        <i class="fa fa-file-word-o"></i>
        دریافت Word
      </b-button>
      <b-tabs pills v-model="tabIndex">
        <b-tab title="چکیده طرح کلان" active lazy>
          <div v-show="false" id="doc">
            <div class="all" style="text-align: right">
              <h1
                style="
                  display: inline-block;
                  text-align: center;
                  padding: 5px 0;
                  border-bottom: 3px solid black;
                "
              >
                کد درخواست طرح کلان:
                <span
                  style="direction: ltr; font-family: Bahnschrift SemiBold"
                  >{{ requestsCode }}</span
                >
              </h1>
              <div>
                <h2 style="color: black; direction: rtl">
                  تاریخ خروجی:
                  <span style="direction: rtl">{{ exportDate }}</span>
                </h2>
                <hr />
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  عنوان و کلیات طرح
                </h2>
                <div>
                  <ul>
                    <li><strong>عنوان طرح کلان: </strong>{{ faSubject }}</li>
                    <li>
                      <strong style="direction: ltr">تاریخ ثبت درخواست: </strong
                      >{{ registerDate }}
                    </li>
                    <li>
                      <strong>عنوان طرح کلان به زبان انگلیسی: </strong
                      >{{ enSubject }}
                    </li>
                    <li>
                      <strong>موضوع طرح کلان: </strong>
                      {{ catId ? catName : "-" }}
                    </li>
                    <li>
                      <strong>حوزه طرح کلان: </strong>
                      <ul>
                        <li v-if="zoneMedicine">سلامت</li>
                        <li v-if="zoneAgriculture">کشاورزی</li>
                        <li v-if="zoneEnvironmentIndustrial">
                          محیط زیست و صنعت
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  مشخصات مجری و راهبر طرح کلان
                </h2>
                <div>
                  <h5 class="text-primary mb-4">مشخصات ریاست دانشگاه</h5>
                  <ul>
                    <li :class="assistantName ? 'done' : 'required'">
                      <b>نام رئیس دانشگاه:</b>
                      {{ assistantName }}
                    </li>
                    <li :class="assistantLastName ? 'done' : 'required'">
                      <b>نام خانوادگی رئیس دانشگاه:</b>
                      {{ assistantLastName }}
                    </li>
                    <li :class="assistantNatcode ? 'done' : 'required'">
                      <b>کد ملی رئیس دانشگاه:</b>
                      {{ assistantNatcode }}
                    </li>
                    <li :class="assistantMobile ? 'done' : 'required'">
                      <b>شماره تلفن همراه رئیس دانشگاه:</b>
                      {{ assistantMobile }}
                    </li>
                  </ul>
                  <hr />
                  <h5 class="text-primary mb-4">مشخصات راهبر طرح کلان</h5>

                  <ul>
                    <li :class="managerName ? 'done' : 'required'">
                      <b>نام راهبر کلان:</b> {{ managerName }}
                    </li>
                    <li :class="managerLastName ? 'done' : 'required'">
                      <b>نام خانوادگی راهبر کلان:</b> {{ managerLastName }}
                    </li>
                    <li :class="managerMobile ? 'done' : 'required'">
                      <b>شماره تلفن همراه راهبر کلان:</b> {{ managerMobile }}
                    </li>
                    <li :class="managerNatcode ? 'done' : 'required'">
                      <b>کد ملی راهبر کلان:</b>
                      {{ managerNatcode }}
                    </li>
                    <li :class="managerEmail ? 'done' : 'required'">
                      <b>آدرس ایمیل راهبر کلان:</b> {{ managerEmail }}
                    </li>
                    <li :class="managerTel ? 'done' : 'required'">
                      <b>تلفن منزل راهبر کلان:</b> {{ managerTel }}
                    </li>
                    <li :class="managerAddress ? 'done' : 'required'">
                      <b>نشانی منزل راهبر کلان:</b> {{ managerAddress }}
                    </li>
                    <li :class="managerStateId ? 'done' : 'required'">
                      <b>استان محل اقامت راهبر کلان:</b>
                      {{ managerStateName ? managerStateName : "-" }}
                    </li>
                    <li :class="managerCityId ? 'done' : 'required'">
                      <b>شهر محل اقامت راهبر کلان:</b>
                      {{ managerCityName ? managerCityName : "-" }}
                    </li>
                    <li :class="managerJobTel ? 'done' : 'required'">
                      <b>شماره تماس محل کار راهبر کلان:</b>
                      {{ managerJobTel }}
                    </li>
                    <li :class="managerJobAddress ? 'done' : 'required'">
                      <b>نشانی محل کار راهبر کلان:</b>
                      {{ managerJobAddress }}
                    </li>
                    <li :class="managerJobStateId ? 'done' : 'required'">
                      <b>استان محل کار راهبر کلان:</b>
                      {{ managerJobStateName ? managerJobStateName : "-" }}
                    </li>
                    <li :class="managerJobCityId ? 'done' : 'required'">
                      <b>شهر محل کار راهبر کلان:</b>
                      {{ managerJobCityName ? managerJobCityName : "-" }}
                    </li>
                    <li :class="managerLastDegree ? 'done' : 'required'">
                      <b>آخرین مدرک تحصیلی راهبر کلان:</b>
                      {{ managerLastDegree }}
                    </li>
                    <li :class="managerAbstract ? 'done' : 'required'">
                      <b>چکیده سوابق علمی، تخصصی و تحقیقاتی راهبر کلان:</b>
                      {{ managerAbstract }}
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  اطلاعات تکمیلی مرتبط با اجرای طرح
                </h2>
                <div>
                  <h5 class="text-primary mb-4">
                    معرفی سایر اعضای هیئت علمی مرتبط
                  </h5>
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="scienceCommittee"
                    :fields="scienceCommitteeFieldDoc"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary mb-4"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>

                  <hr />
                  <h5 class="text-primary mb-4">سوابق مرتبط با موضوع طرح</h5>

                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="relatedHistories"
                    :fields="relatedHistoriesFieldDoc"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary mb-4"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  سطح‌بندی طرح
                </h2>
                <div>
                  <ul>
                    <li
                      class="mb-4"
                      :class="managementAbstract ? 'done' : 'required'"
                    >
                      <b>خلاصه مدیریتی:</b> {{ managementAbstract }}
                    </li>
                    <li class="mb-4" :class="'done'">
                      <b> خروجی‌های طرح کلان (مگا پروژه):</b>
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="megaOutputs"
                        :fields="megaOutputsFieldDoc"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary my-3"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                      </b-table>
                    </li>
                    <li class="mb-4" :class="abstract ? 'done' : 'required'">
                      <b>چکیده طرح:</b> {{ abstract }}
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  ساختار شکست کار (WBS)
                </h2>
                <h4 class="mb-6" :class="'done'">
                  جدول اطلاعات طرح سطح میانی (بلوک) 1:
                </h4>
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="minorData1"
                  :fields="minorDataFieldDoc"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary mb-4"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(budget)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ parseInt(data.value).toLocaleString() }}
                    </div>
                  </template>
                </b-table>
                <hr />
                <h4 class="mb-6" :class="'done'">
                  جدول اطلاعات طرح سطح میانی (بلوک) 2:
                </h4>
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="minorData2"
                  :fields="minorDataFieldDoc"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary mb-4"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(budget)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ parseInt(data.value).toLocaleString() }}
                    </div>
                  </template>
                </b-table>
                <hr v-if="minorData3.length" />
                <h4 class="mb-6" v-if="minorData3.length" :class="'done'">
                  جدول اطلاعات طرح سطح میانی (بلوک) 3:
                </h4>
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="minorData3"
                  :fields="minorDataFieldDoc"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary mb-4"
                  v-if="minorData3.length"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(budget)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ parseInt(data.value).toLocaleString() }}
                    </div>
                  </template>
                </b-table>
                <hr v-if="minorData4.length" />
                <h4 class="mb-6" v-if="minorData4.length" :class="'done'">
                  جدول اطلاعات طرح سطح میانی (بلوک) 4:
                </h4>
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="minorData4"
                  :fields="minorDataFieldDoc"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary mb-4"
                  v-if="minorData4.length"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(budget)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ parseInt(data.value).toLocaleString() }}
                    </div>
                  </template>
                </b-table>
                <hr v-if="minorData5.length" />
                <h4 class="mb-6" v-if="minorData5.length" :class="'done'">
                  جدول اطلاعات طرح سطح میانی (بلوک) 4:
                </h4>
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="minorData5"
                  :fields="minorDataFieldDoc"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary mb-4"
                  v-if="minorData5.length"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(budget)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ parseInt(data.value).toLocaleString() }}
                    </div>
                  </template>
                </b-table>
                <hr v-if="minorData6.length" />
                <h4 class="mb-6" v-if="minorData6.length" :class="'done'">
                  جدول اطلاعات طرح سطح میانی (بلوک) 66:
                </h4>
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="minorData6"
                  :fields="minorDataFieldDoc"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary mb-4"
                  v-if="minorData6.length"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(budget)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ parseInt(data.value).toLocaleString() }}
                    </div>
                  </template>
                </b-table>
                <hr v-if="minorData7.length" />
                <h4 class="mb-6" v-if="minorData7.length" :class="'done'">
                  جدول اطلاعات طرح سطح میانی (بلوک) 7:
                </h4>
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="minorData7"
                  :fields="minorDataFieldDoc"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary mb-4"
                  v-if="minorData7.length"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(budget)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ parseInt(data.value).toLocaleString() }}
                    </div>
                  </template>
                </b-table>
                <hr v-if="minorData8.length" />
                <h4 class="mb-6" v-if="minorData8.length" :class="'done'">
                  جدول اطلاعات طرح سطح میانی (بلوک) 8:
                </h4>
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="minorData8"
                  :fields="minorDataFieldDoc"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary mb-4"
                  v-if="minorData8.length"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(budget)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ parseInt(data.value).toLocaleString() }}
                    </div>
                  </template>
                </b-table>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  زمان‌بندی و فازبندی طرح کلان (مگا پروژه)
                </h2>
                <div>
                  <strong>زمان آغاز: </strong>
                  {{ startDate || "—" }}
                  <br />
                  <strong>زمان پایان: </strong>
                  {{ finalDate || "—" }}
                  <br />
                  <strong>مدت زمان اجرا: </strong>
                  {{ duration ? duration + " روز" : "—" }}
                  <br />
                </div>
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="gantData"
                  :fields="serviceFieldsDoc"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                </b-table>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  هزینه‌ها
                </h2>
                <h4 class="mb-0">هزینه‌ها و مدیریت مالی</h4>

                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="expenses"
                  :fields="expensesFieldsDoc"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary mb-4"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(expense)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ parseInt(data.value).toLocaleString() }}
                    </div>
                  </template>
                </b-table>
                <p>
                  جمع کل هزینه‌ها:
                  {{
                    expenses.length == 0
                      ? 0
                      : expenses
                          .map((x) => parseInt(x.expense))
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                          .toLocaleString()
                  }}
                  ريال
                </p>
                <hr />
                <h3>
                  بودجه درخواستی:
                  {{ budget.toLocaleString() }}
                  ریال
                </h3>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  تعهدات
                </h2>
                <div>
                  <ul>
                    <li v-if="promiseArrays[0]">
                      اينجانب
                      {{ `"${assistantName} ${assistantLastName}" ` }}
                      رئیس دانشگاه
                      {{ `"${universityName}" ` }}
                      بدينوسيله مراتب فوق را تأييد می‌نمایم.
                    </li>
                    <li v-if="promiseArrays[1]">
                      اينجانب
                      {{ `"${managerName} ${managerLastName}" ` }}
                      راهبر طرح کلان دانشگاه
                      {{ `"${universityName}" ` }}
                      بدينوسيله مراتب فوق را تأييد می‌نمایم.
                    </li>
                    <li v-if="promiseArrays[2]">
                      تكميل اين پروپوزال دليل بر تصويب طرح نمی‌باشد.
                    </li>
                    <li v-if="promiseArrays[3]">
                      مجری پروژه صحت مندرجات اين پروپوزال را تأييد مي نمايد.
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
            </div>
          </div>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-2 variant="light">
                <h5 class="mb-0" style="display: inline-block">کلیات طرح</h5>
              </b-button>
            </b-card-header>

            <b-collapse
              id="accordion-2"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <ul>
                    <li :class="faSubject ? 'done' : 'required'">
                      <b>عنوان طرح کلان به زبان فارسی:</b> {{ faSubject }}
                    </li>
                    <li :class="enSubject ? 'done' : 'required'">
                      <b>عنوان طرح کلان به زبان انگلیسی:</b> {{ enSubject }}
                    </li>
                    <li :class="catId ? 'done' : 'required'">
                      <b>موضوع طرح کلان:</b>
                      {{ catId ? catName : "-" }}
                    </li>

                    <li
                      :class="
                        zoneMedicine ||
                        zoneAgriculture ||
                        zoneEnvironmentIndustrial
                          ? 'done'
                          : 'required'
                      "
                    >
                      <b>حوزه طرح کلان:</b>
                      <b-form-group disabled>
                        <b-form-checkbox v-model="zoneMedicine"
                          >سلامت</b-form-checkbox
                        >
                        <b-form-checkbox v-model="zoneAgriculture"
                          >کشاورزی</b-form-checkbox
                        >
                        <b-form-checkbox v-model="zoneEnvironmentIndustrial"
                          >محیط زیست و صنعت</b-form-checkbox
                        >
                      </b-form-group>
                    </li>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-3 variant="warning">
                <h5 class="mb-0" style="display: inline-block">
                  مشخصات مجری و راهبر طرح کلان
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-3"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <h5 class="text-primary mb-4">مشخصات رئیس دانشگاه</h5>
                  <ul>
                    <li :class="assistantName ? 'done' : 'required'">
                      <b>نام رئیس دانشگاه:</b>
                      {{ assistantName }}
                    </li>
                    <li :class="assistantLastName ? 'done' : 'required'">
                      <b>نام خانوادگی رئیس دانشگاه:</b>
                      {{ assistantLastName }}
                    </li>
                    <li :class="assistantNatcode ? 'done' : 'required'">
                      <b>کد ملی رئیس دانشگاه:</b>
                      {{ assistantNatcode }}
                    </li>
                    <li :class="assistantMobile ? 'done' : 'required'">
                      <b>شماره تلفن همراه رئیس دانشگاه:</b>
                      {{ assistantMobile }}
                    </li>
                  </ul>
                  <hr />
                  <h5 class="text-primary mb-4">مشخصات راهبر طرح کلان</h5>

                  <ul>
                    <li :class="managerName ? 'done' : 'required'">
                      <b>نام راهبر کلان:</b> {{ managerName }}
                    </li>
                    <li :class="managerLastName ? 'done' : 'required'">
                      <b>نام خانوادگی راهبر کلان:</b> {{ managerLastName }}
                    </li>
                    <li :class="managerMobile ? 'done' : 'required'">
                      <b>شماره تلفن همراه راهبر کلان:</b> {{ managerMobile }}
                    </li>
                    <li :class="managerNatcode ? 'done' : 'required'">
                      <b>کد ملی راهبر کلان:</b>
                      {{ managerNatcode }}
                    </li>
                    <li :class="managerEmail ? 'done' : 'required'">
                      <b>آدرس ایمیل راهبر کلان:</b> {{ managerEmail }}
                    </li>
                    <li :class="managerTel ? 'done' : 'required'">
                      <b>تلفن منزل راهبر کلان:</b> {{ managerTel }}
                    </li>
                    <li :class="managerAddress ? 'done' : 'required'">
                      <b>نشانی منزل راهبر کلان:</b> {{ managerAddress }}
                    </li>
                    <li :class="managerStateId ? 'done' : 'required'">
                      <b>استان محل اقامت راهبر کلان:</b>
                      {{ managerStateName ? managerStateName : "-" }}
                    </li>
                    <li :class="managerCityId ? 'done' : 'required'">
                      <b>شهر محل اقامت راهبر کلان:</b>
                      {{ managerCityName ? managerCityName : "-" }}
                    </li>
                    <li :class="managerJobTel ? 'done' : 'required'">
                      <b>شماره تماس محل کار راهبر کلان:</b>
                      {{ managerJobTel }}
                    </li>
                    <li :class="managerJobAddress ? 'done' : 'required'">
                      <b>نشانی محل کار راهبر کلان:</b>
                      {{ managerJobAddress }}
                    </li>
                    <li :class="managerJobStateId ? 'done' : 'required'">
                      <b>استان محل کار راهبر کلان:</b>
                      {{ managerJobStateName ? managerJobStateName : "-" }}
                    </li>
                    <li :class="managerJobCityId ? 'done' : 'required'">
                      <b>شهر محل کار راهبر کلان:</b>
                      {{ managerJobCityName ? managerJobCityName : "-" }}
                    </li>
                    <li :class="managerLastDegree ? 'done' : 'required'">
                      <b>آخرین مدرک تحصیلی راهبر کلان:</b>
                      {{ managerLastDegree }}
                    </li>
                    <li :class="managerAbstract ? 'done' : 'required'">
                      <b>چکیده سوابق علمی، تخصصی و تحقیقاتی راهبر کلان:</b>
                      {{ managerAbstract }}
                    </li>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-4 variant="info">
                <h5 class="mb-0 text-white" style="display: inline-block">
                  اطلاعات تکمیلی مرتبط با اجرای طرح
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-4"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <h5 class="text-primary mb-4">
                    معرفی سایر اعضای هیئت علمی مرتبط
                  </h5>
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="scienceCommittee"
                    :fields="scienceCommitteeField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary mb-4"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>

                  <hr />
                  <h5 class="text-primary mb-4">سوابق مرتبط با موضوع طرح</h5>

                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="relatedHistories"
                    :fields="relatedHistoriesField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary mb-4"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-5 variant="info">
                <h5 class="mb-0 text-white" style="display: inline-block">
                  سطح‌بندی طرح
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-5"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <ul>
                    <li
                      class="mb-4"
                      :class="managementAbstract ? 'done' : 'required'"
                    >
                      <b>خلاصه مدیریتی:</b> {{ managementAbstract }}
                    </li>
                    <li class="mb-4" :class="'done'">
                      <b> خروجی‌های طرح کلان (مگا پروژه):</b>
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="megaOutputs"
                        :fields="megaOutputsField"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary my-3"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                      </b-table>
                    </li>
                    <li class="mb-4" :class="abstract ? 'done' : 'required'">
                      <b>چکیده طرح:</b> {{ abstract }}
                    </li>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-6 variant="warning">
                <h5 class="mb-0" style="display: inline-block">
                  ساختار شکست کار (WBS)
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-6"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="p-3 shadow">
                  <h4 class="mb-6" :class="'done'">
                    جدول اطلاعات طرح سطح میانی (بلوک) 1:
                  </h4>
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="minorData1"
                    :fields="minorDataField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary mb-4"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:cell(budget)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ parseInt(data.value).toLocaleString() }}
                      </div>
                    </template>
                  </b-table>
                  <hr />
                  <h4 class="mb-6" :class="'done'">
                    جدول اطلاعات طرح سطح میانی (بلوک) 2:
                  </h4>
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="minorData2"
                    :fields="minorDataField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary mb-4"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:cell(budget)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ parseInt(data.value).toLocaleString() }}
                      </div>
                    </template>
                  </b-table>
                  <hr v-if="minorData3.length" />
                  <h4 class="mb-6" v-if="minorData3.length" :class="'done'">
                    جدول اطلاعات طرح سطح میانی (بلوک) 3:
                  </h4>
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="minorData3"
                    :fields="minorDataField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary mb-4"
                    v-if="minorData3.length"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:cell(budget)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ parseInt(data.value).toLocaleString() }}
                      </div>
                    </template>
                  </b-table>
                  <hr v-if="minorData4.length" />
                  <h4 class="mb-6" v-if="minorData4.length" :class="'done'">
                    جدول اطلاعات طرح سطح میانی (بلوک) 4:
                  </h4>
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="minorData4"
                    :fields="minorDataField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary mb-4"
                    v-if="minorData4.length"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:cell(budget)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ parseInt(data.value).toLocaleString() }}
                      </div>
                    </template>
                  </b-table>
                  <hr v-if="minorData5.length" />
                  <h4 class="mb-6" v-if="minorData5.length" :class="'done'">
                    جدول اطلاعات طرح سطح میانی (بلوک) 5:
                  </h4>
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="minorData5"
                    :fields="minorDataField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary mb-4"
                    v-if="minorData5.length"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:cell(budget)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ parseInt(data.value).toLocaleString() }}
                      </div>
                    </template>
                  </b-table>
                  <hr v-if="minorData6.length" />
                  <h4 class="mb-6" v-if="minorData6.length" :class="'done'">
                    جدول اطلاعات طرح سطح میانی (بلوک) 6:
                  </h4>
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="minorData6"
                    :fields="minorDataField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary mb-4"
                    v-if="minorData6.length"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:cell(budget)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ parseInt(data.value).toLocaleString() }}
                      </div>
                    </template>
                  </b-table>
                  <hr v-if="minorData7.length" />
                  <h4 class="mb-6" v-if="minorData7.length" :class="'done'">
                    جدول اطلاعات طرح سطح میانی (بلوک) 7:
                  </h4>
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="minorData7"
                    :fields="minorDataField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary mb-4"
                    v-if="minorData7.length"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:cell(budget)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ parseInt(data.value).toLocaleString() }}
                      </div>
                    </template>
                  </b-table>
                  <hr v-if="minorData8.length" />
                  <h4 class="mb-6" v-if="minorData8.length" :class="'done'">
                    جدول اطلاعات طرح سطح میانی (بلوک) 8:
                  </h4>
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="minorData8"
                    :fields="minorDataField"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary mb-4"
                    v-if="minorData8.length"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:cell(budget)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ parseInt(data.value).toLocaleString() }}
                      </div>
                    </template>
                  </b-table>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-7 variant="light">
                <h5 class="mb-0" style="display: inline-block">زمانبندی طرح</h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-7"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                زمان‌بندی و فازبندی طرح کلان (مگا پروژه)
                <b-card-text class="shadow p-3">
                  <b-card class="flex-grow-1 shadow-sm border-0 p-3">
                    <b-row>
                      <b-col md="4" class="text-center border-right">
                        <div class="text-muted small mb-1">زمان آغاز</div>
                        <div class="font-weight-bold text-primary">
                          {{ startDate || "—" }}
                        </div>
                      </b-col>

                      <b-col md="4" class="text-center border-right">
                        <div class="text-muted small mb-1">زمان پایان</div>
                        <div class="font-weight-bold text-primary">
                          {{ finalDate || "—" }}
                        </div>
                      </b-col>

                      <b-col md="4" class="text-center">
                        <div class="text-muted small mb-1">مدت زمان اجرا</div>
                        <div class="font-weight-bold text-primary">
                          {{ duration ? duration + " روز" : "—" }}
                        </div>
                      </b-col>
                    </b-row>
                  </b-card>

                  <div>
                    <sarmadGantt
                      v-if="show"
                      :items="gantData"
                      :fields="serviceFields"
                    />
                  </div>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-8 variant="dark">
                <h5 class="mb-0" style="display: inline-block">هزینه‌ها</h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-8"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <h4 class="mb-0">هزینه‌ها و مدیریت مالی</h4>

                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="expenses"
                    :fields="expensesFields"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary mb-4"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:cell(expense)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ parseInt(data.value).toLocaleString() }}
                      </div>
                    </template>
                  </b-table>
                  <p>
                    جمع کل هزینه‌ها:
                    {{
                      expenses.length == 0
                        ? 0
                        : expenses
                            .map((x) => parseInt(x.expense))
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                            .toLocaleString()
                    }}
                    ريال
                  </p>
                  <hr />
                  <h3>
                    بودجه درخواستی:
                    {{ budget.toLocaleString() }}
                    ریال
                  </h3>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-11 variant="dark">
                <h5 class="mb-0" style="display: inline-block">تعهدات</h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-11"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="shadow p-3">
                  <b-form-group disabled>
                    <b-form-checkbox v-model="promiseArrays[0]">
                      <b :class="promiseArrays[0] ? 'done' : 'required'">
                        اينجانب
                        {{ `"${assistantName} ${assistantLastName}" ` }}
                        رئیس دانشگاه
                        {{ `"${universityName}" ` }}
                        بدينوسيله مراتب فوق را تأييد می‌نمایم.</b
                      >
                    </b-form-checkbox>
                    <b-form-checkbox v-model="promiseArrays[1]">
                      <b :class="promiseArrays[1] ? 'done' : 'required'">
                        اينجانب
                        {{ `"${managerName} ${managerLastName}" ` }}
                        راهبر طرح کلان دانشگاه
                        {{ `"${universityName}" ` }}
                        بدينوسيله مراتب فوق را تأييد می‌نمایم.
                      </b>
                    </b-form-checkbox>
                    <b-form-checkbox v-model="promiseArrays[2]"
                      ><b :class="promiseArrays[2] ? 'done' : 'required'">
                        تكميل اين پروپوزال دليل بر تصويب طرح نمی‌باشد.
                      </b></b-form-checkbox
                    >
                    <b-form-checkbox v-model="promiseArrays[3]"
                      ><b :class="promiseArrays[3] ? 'done' : 'required'"
                        >مجری پروژه صحت مندرجات اين پروپوزال را تأييد مي
                        نمايد.</b
                      ></b-form-checkbox
                    >
                  </b-form-group>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-tab>
        <b-tab
          v-if="role == 'university' && status == 'پذیرش اولیه'"
          title="قرارداد"
        >
          <b-row class="mb-2 pt-2 my-1" align-v="center">
            <i
              class="fa fa-exclamation-triangle fa-2x text-warning mb-1 ml-3"
              aria-hidden="true"
            ></i>
            <p class="mt-2 ml-2">
              لطفا فایل قرارداد را دانلود کرده و سپس توسط مسئولین مربوطه امضا
              نمایید.
              <br />
              پس از آن قرارداد امضا شده را برای ستاد زیست‌‌فناوری ارسال نمایید.
            </p>

            <b-col cols="12" class="text-center mt-3">
              <a
                class="btn btn-success white--text"
                :href="contractFileData.url"
                target="_blank"
              >
                دریافت قرارداد
              </a>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab v-if="role == 'admin' && isArchive" title="نسخه‌های پیشین">
          <b-tabs vertical pills fill>
            <b-tab v-for="(old, index) in archives" :key="index">
              <template slot="title">
                <div class="d-flex flex-column align-items-center">
                  {{ "نسخه" + " " + Number(archives.length - index) }}
                  <p class="mb-0">({{ old.registerDate }})</p>
                </div>
              </template>
              <b-tabs pills>
                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-2 variant="light">
                      <h5 class="mb-0" style="display: inline-block">
                        کلیات طرح
                      </h5>
                    </b-button>
                  </b-card-header>

                  <b-collapse
                    id="accordion-2"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text class="shadow p-3">
                        <ul>
                          <li :class="old.faSubject ? 'done' : 'required'">
                            <b>عنوان طرح کلان به زبان فارسی:</b>
                            {{ old.faSubject }}
                          </li>
                          <li :class="old.enSubject ? 'done' : 'required'">
                            <b>عنوان طرح کلان به زبان انگلیسی:</b>
                            {{ old.enSubject }}
                          </li>
                          <li :class="old.catId ? 'done' : 'required'">
                            <b>موضوع طرح کلان:</b>
                            {{ old.catId ? old.catName : "-" }}
                          </li>

                          <li
                            :class="
                              old.zoneMedicine ||
                              old.zoneAgriculture ||
                              old.zoneEnvironmentIndustrial
                                ? 'done'
                                : 'required'
                            "
                          >
                            <b>حوزه طرح کلان:</b>
                            <b-form-group disabled>
                              <b-form-checkbox v-model="old.zoneMedicine"
                                >سلامت</b-form-checkbox
                              >
                              <b-form-checkbox v-model="old.zoneAgriculture"
                                >کشاورزی</b-form-checkbox
                              >
                              <b-form-checkbox
                                v-model="old.zoneEnvironmentIndustrial"
                                >محیط زیست و صنعت</b-form-checkbox
                              >
                            </b-form-group>
                          </li>
                        </ul>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-3 variant="warning">
                      <h5 class="mb-0" style="display: inline-block">
                        مشخصات مجری و راهبر طرح کلان
                      </h5>
                    </b-button>
                  </b-card-header>
                  <b-collapse
                    id="accordion-3"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text class="shadow p-3">
                        <h5 class="text-primary mb-4">مشخصات رئیس دانشگاه</h5>
                        <ul>
                          <li :class="old.assistantName ? 'done' : 'required'">
                            <b>نام رئیس دانشگاه:</b>
                            {{ old.assistantName }}
                          </li>
                          <li
                            :class="old.assistantLastName ? 'done' : 'required'"
                          >
                            <b>نام خانوادگی رئیس دانشگاه:</b>
                            {{ old.assistantLastName }}
                          </li>
                          <li
                            :class="old.assistantNatcode ? 'done' : 'required'"
                          >
                            <b>کد ملی رئیس دانشگاه:</b>
                            {{ old.assistantNatcode }}
                          </li>
                          <li
                            :class="old.assistantMobile ? 'done' : 'required'"
                          >
                            <b>شماره تلفن همراه رئیس دانشگاه:</b>
                            {{ old.assistantMobile }}
                          </li>
                        </ul>
                        <hr />
                        <h5 class="text-primary mb-4">مشخصات راهبر طرح کلان</h5>

                        <ul>
                          <li :class="old.managerName ? 'done' : 'required'">
                            <b>نام راهبر کلان:</b> {{ old.managerName }}
                          </li>
                          <li
                            :class="old.managerLastName ? 'done' : 'required'"
                          >
                            <b>نام خانوادگی راهبر کلان:</b>
                            {{ old.managerLastName }}
                          </li>
                          <li :class="old.managerMobile ? 'done' : 'required'">
                            <b>شماره تلفن همراه راهبر کلان:</b>
                            {{ old.managerMobile }}
                          </li>
                          <li :class="old.managerNatcode ? 'done' : 'required'">
                            <b>کد ملی راهبر کلان:</b>
                            {{ old.managerNatcode }}
                          </li>
                          <li :class="old.managerEmail ? 'done' : 'required'">
                            <b>آدرس ایمیل راهبر کلان:</b> {{ old.managerEmail }}
                          </li>
                          <li :class="old.managerTel ? 'done' : 'required'">
                            <b>تلفن منزل راهبر کلان:</b> {{ old.managerTel }}
                          </li>
                          <li :class="old.managerAddress ? 'done' : 'required'">
                            <b>نشانی منزل راهبر کلان:</b>
                            {{ old.managerAddress }}
                          </li>
                          <li :class="old.managerStateId ? 'done' : 'required'">
                            <b>استان محل اقامت راهبر کلان:</b>
                            {{
                              old.managerStateName ? old.managerStateName : "-"
                            }}
                          </li>
                          <li :class="old.managerCityId ? 'done' : 'required'">
                            <b>شهر محل اقامت راهبر کلان:</b>
                            {{
                              old.managerCityName ? old.managerCityName : "-"
                            }}
                          </li>
                          <li :class="old.managerJobTel ? 'done' : 'required'">
                            <b>شماره تماس محل کار راهبر کلان:</b>
                            {{ old.managerJobTel }}
                          </li>
                          <li
                            :class="old.managerJobAddress ? 'done' : 'required'"
                          >
                            <b>نشانی محل کار راهبر کلان:</b>
                            {{ old.managerJobAddress }}
                          </li>
                          <li
                            :class="old.managerJobStateId ? 'done' : 'required'"
                          >
                            <b>استان محل کار راهبر کلان:</b>
                            {{
                              old.managerJobStateName
                                ? old.managerJobStateName
                                : "-"
                            }}
                          </li>
                          <li
                            :class="old.managerJobCityId ? 'done' : 'required'"
                          >
                            <b>شهر محل کار راهبر کلان:</b>
                            {{
                              old.managerJobCityName
                                ? old.managerJobCityName
                                : "-"
                            }}
                          </li>
                          <li
                            :class="old.managerLastDegree ? 'done' : 'required'"
                          >
                            <b>آخرین مدرک تحصیلی راهبر کلان:</b>
                            {{ old.managerLastDegree }}
                          </li>
                          <li
                            :class="old.managerAbstract ? 'done' : 'required'"
                          >
                            <b
                              >چکیده سوابق علمی، تخصصی و تحقیقاتی راهبر کلان:</b
                            >
                            {{ old.managerAbstract }}
                          </li>
                        </ul>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-4 variant="info">
                      <h5 class="mb-0 text-white" style="display: inline-block">
                        اطلاعات تکمیلی مرتبط با اجرای طرح
                      </h5>
                    </b-button>
                  </b-card-header>
                  <b-collapse
                    id="accordion-4"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text class="shadow p-3">
                        <h5 class="text-primary mb-4">
                          معرفی سایر اعضای هیئت علمی مرتبط
                        </h5>
                        <b-table
                          responsive
                          small
                          show-empty
                          head-variant="dark"
                          :items="old.scienceCommittee"
                          :fields="scienceCommitteeField"
                          empty-text="رکوردی برای نمایش وجود ندارد"
                          class="table table-secondary mb-4"
                        >
                          <template v-slot:head()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.label }}
                            </div>
                          </template>
                          <template v-slot:cell()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.value }}
                            </div>
                          </template>
                          <template v-slot:cell(index)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.index + 1 }}
                            </div>
                          </template>
                        </b-table>

                        <hr />
                        <h5 class="text-primary mb-4">
                          سوابق مرتبط با موضوع طرح
                        </h5>

                        <b-table
                          responsive
                          small
                          show-empty
                          head-variant="dark"
                          :items="old.relatedHistories"
                          :fields="relatedHistoriesField"
                          empty-text="رکوردی برای نمایش وجود ندارد"
                          class="table table-secondary mb-4"
                        >
                          <template v-slot:head()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.label }}
                            </div>
                          </template>
                          <template v-slot:cell()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.value }}
                            </div>
                          </template>
                          <template v-slot:cell(index)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.index + 1 }}
                            </div>
                          </template>
                        </b-table>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-5 variant="info">
                      <h5 class="mb-0 text-white" style="display: inline-block">
                        سطح‌بندی طرح
                      </h5>
                    </b-button>
                  </b-card-header>
                  <b-collapse
                    id="accordion-5"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text class="shadow p-3">
                        <ul>
                          <li
                            class="mb-4"
                            :class="
                              old.managementAbstract ? 'done' : 'required'
                            "
                          >
                            <b>خلاصه مدیریتی:</b> {{ old.managementAbstract }}
                          </li>
                          <li class="mb-4" :class="'done'">
                            <b> خروجی‌های طرح کلان (مگا پروژه):</b>
                            <b-table
                              responsive
                              small
                              show-empty
                              head-variant="dark"
                              :items="old.megaOutputs"
                              :fields="megaOutputsField"
                              empty-text="رکوردی برای نمایش وجود ندارد"
                              class="table table-secondary my-3"
                            >
                              <template v-slot:head()="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.label }}
                                </div>
                              </template>
                              <template v-slot:cell()="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.value }}
                                </div>
                              </template>
                              <template v-slot:cell(index)="data">
                                <div
                                  style="
                                    text-align: center;
                                    vertical-align: middle;
                                  "
                                >
                                  {{ data.index + 1 }}
                                </div>
                              </template>
                            </b-table>
                          </li>
                          <li
                            class="mb-4"
                            :class="old.abstract ? 'done' : 'required'"
                          >
                            <b>چکیده طرح:</b> {{ old.abstract }}
                          </li>
                        </ul>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-6 variant="warning">
                      <h5 class="mb-0" style="display: inline-block">
                        ساختار شکست کار (WBS)
                      </h5>
                    </b-button>
                  </b-card-header>
                  <b-collapse
                    id="accordion-6"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text class="p-3 shadow">
                        <h4 class="mb-6" :class="'done'">
                          جدول اطلاعات طرح سطح میانی (بلوک) 1:
                        </h4>
                        <b-table
                          responsive
                          small
                          show-empty
                          head-variant="dark"
                          :items="old.minorData1"
                          :fields="minorDataField"
                          empty-text="رکوردی برای نمایش وجود ندارد"
                          class="table table-secondary mb-4"
                        >
                          <template v-slot:head()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.label }}
                            </div>
                          </template>
                          <template v-slot:cell()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.value }}
                            </div>
                          </template>
                          <template v-slot:cell(index)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.index + 1 }}
                            </div>
                          </template>
                          <template v-slot:cell(budget)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ parseInt(data.value).toLocaleString() }}
                            </div>
                          </template>
                        </b-table>
                        <hr />
                        <h4 class="mb-6" :class="'done'">
                          جدول اطلاعات طرح سطح میانی (بلوک) 2:
                        </h4>
                        <b-table
                          responsive
                          small
                          show-empty
                          head-variant="dark"
                          :items="old.minorData2"
                          :fields="minorDataField"
                          empty-text="رکوردی برای نمایش وجود ندارد"
                          class="table table-secondary mb-4"
                        >
                          <template v-slot:head()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.label }}
                            </div>
                          </template>
                          <template v-slot:cell()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.value }}
                            </div>
                          </template>
                          <template v-slot:cell(index)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.index + 1 }}
                            </div>
                          </template>
                          <template v-slot:cell(budget)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ parseInt(data.value).toLocaleString() }}
                            </div>
                          </template>
                        </b-table>
                        <hr />
                        <h4
                          class="mb-6"
                          v-if="old.minorData3.length"
                          :class="'done'"
                        >
                          جدول اطلاعات طرح سطح میانی (بلوک) 3:
                        </h4>
                        <b-table
                          responsive
                          small
                          show-empty
                          head-variant="dark"
                          :items="old.minorData3"
                          :fields="minorDataField"
                          empty-text="رکوردی برای نمایش وجود ندارد"
                          class="table table-secondary mb-4"
                          v-if="old.minorData3.length"
                        >
                          <template v-slot:head()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.label }}
                            </div>
                          </template>
                          <template v-slot:cell()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.value }}
                            </div>
                          </template>
                          <template v-slot:cell(index)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.index + 1 }}
                            </div>
                          </template>
                          <template v-slot:cell(budget)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ parseInt(data.value).toLocaleString() }}
                            </div>
                          </template>
                        </b-table>
                        <hr />
                        <h4
                          class="mb-6"
                          v-if="minorData4.length"
                          :class="'done'"
                        >
                          جدول اطلاعات طرح سطح میانی (بلوک) 4:
                        </h4>
                        <b-table
                          responsive
                          small
                          show-empty
                          head-variant="dark"
                          :items="old.minorData4"
                          :fields="minorDataField"
                          empty-text="رکوردی برای نمایش وجود ندارد"
                          class="table table-secondary mb-4"
                          v-if="old.minorData4.length"
                        >
                          <template v-slot:head()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.label }}
                            </div>
                          </template>
                          <template v-slot:cell()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.value }}
                            </div>
                          </template>
                          <template v-slot:cell(index)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.index + 1 }}
                            </div>
                          </template>
                          <template v-slot:cell(budget)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ parseInt(data.value).toLocaleString() }}
                            </div>
                          </template>
                        </b-table>
                        <hr />
                        <h4
                          class="mb-6"
                          v-if="old.minorData5.length"
                          :class="'done'"
                        >
                          جدول اطلاعات طرح سطح میانی (بلوک) 5:
                        </h4>
                        <b-table
                          responsive
                          small
                          show-empty
                          head-variant="dark"
                          :items="old.minorData5"
                          :fields="minorDataField"
                          empty-text="رکوردی برای نمایش وجود ندارد"
                          class="table table-secondary mb-4"
                          v-if="old.minorData5.length"
                        >
                          <template v-slot:head()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.label }}
                            </div>
                          </template>
                          <template v-slot:cell()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.value }}
                            </div>
                          </template>
                          <template v-slot:cell(index)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.index + 1 }}
                            </div>
                          </template>
                          <template v-slot:cell(budget)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ parseInt(data.value).toLocaleString() }}
                            </div>
                          </template>
                        </b-table>
                        <hr />
                        <h4
                          class="mb-6"
                          v-if="old.minorData6.length"
                          :class="'done'"
                        >
                          جدول اطلاعات طرح سطح میانی (بلوک) 6:
                        </h4>
                        <b-table
                          responsive
                          small
                          show-empty
                          head-variant="dark"
                          :items="old.minorData6"
                          :fields="minorDataField"
                          empty-text="رکوردی برای نمایش وجود ندارد"
                          class="table table-secondary mb-4"
                          v-if="old.minorData6.length"
                        >
                          <template v-slot:head()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.label }}
                            </div>
                          </template>
                          <template v-slot:cell()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.value }}
                            </div>
                          </template>
                          <template v-slot:cell(index)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.index + 1 }}
                            </div>
                          </template>
                          <template v-slot:cell(budget)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ parseInt(data.value).toLocaleString() }}
                            </div>
                          </template>
                        </b-table>
                        <hr />
                        <h4
                          class="mb-6"
                          v-if="old.minorData7.length"
                          :class="'done'"
                        >
                          جدول اطلاعات طرح سطح میانی (بلوک) 7:
                        </h4>
                        <b-table
                          responsive
                          small
                          show-empty
                          head-variant="dark"
                          :items="old.minorData7"
                          :fields="minorDataField"
                          empty-text="رکوردی برای نمایش وجود ندارد"
                          class="table table-secondary mb-4"
                          v-if="old.minorData7.length"
                        >
                          <template v-slot:head()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.label }}
                            </div>
                          </template>
                          <template v-slot:cell()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.value }}
                            </div>
                          </template>
                          <template v-slot:cell(index)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.index + 1 }}
                            </div>
                          </template>
                          <template v-slot:cell(budget)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ parseInt(data.value).toLocaleString() }}
                            </div>
                          </template>
                        </b-table>
                        <hr />
                        <h4
                          class="mb-6"
                          v-if="old.minorData8.length"
                          :class="'done'"
                        >
                          جدول اطلاعات طرح سطح میانی (بلوک) 8:
                        </h4>
                        <b-table
                          responsive
                          small
                          show-empty
                          head-variant="dark"
                          :items="old.minorData8"
                          :fields="minorDataField"
                          empty-text="رکوردی برای نمایش وجود ندارد"
                          class="table table-secondary mb-4"
                          v-if="old.minorData8.length"
                        >
                          <template v-slot:head()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.label }}
                            </div>
                          </template>
                          <template v-slot:cell()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.value }}
                            </div>
                          </template>
                          <template v-slot:cell(index)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.index + 1 }}
                            </div>
                          </template>
                          <template v-slot:cell(budget)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ parseInt(data.value).toLocaleString() }}
                            </div>
                          </template>
                        </b-table>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-7 variant="light">
                      <h5 class="mb-0" style="display: inline-block">
                        زمانبندی طرح
                      </h5>
                    </b-button>
                  </b-card-header>
                  <b-collapse
                    id="accordion-7"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      زمان‌بندی و فازبندی طرح کلان (مگا پروژه)
                      <b-card-text class="shadow p-3">
                        <b-card class="flex-grow-1 shadow-sm border-0 p-3">
                          <b-row>
                            <b-col md="4" class="text-center border-right">
                              <div class="text-muted small mb-1">زمان آغاز</div>
                              <div class="font-weight-bold text-primary">
                                {{ old.startDate || "—" }}
                              </div>
                            </b-col>

                            <b-col md="4" class="text-center border-right">
                              <div class="text-muted small mb-1">
                                زمان پایان
                              </div>
                              <div class="font-weight-bold text-primary">
                                {{ old.finalDate || "—" }}
                              </div>
                            </b-col>

                            <b-col md="4" class="text-center">
                              <div class="text-muted small mb-1">
                                مدت زمان اجرا
                              </div>
                              <div class="font-weight-bold text-primary">
                                {{ old.duration ? old.duration + " روز" : "—" }}
                              </div>
                            </b-col>
                          </b-row>
                        </b-card>

                        <div>
                          <sarmadGantt
                            v-if="show"
                            :items="old.gantData"
                            :fields="serviceFields"
                          />
                        </div>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-8 variant="dark">
                      <h5 class="mb-0" style="display: inline-block">
                        هزینه‌ها
                      </h5>
                    </b-button>
                  </b-card-header>
                  <b-collapse
                    id="accordion-8"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text class="shadow p-3">
                        <h4 class="mb-0">هزینه‌ها و مدیریت مالی</h4>

                        <b-table
                          responsive
                          small
                          show-empty
                          head-variant="dark"
                          :items="old.expenses"
                          :fields="expensesFields"
                          empty-text="رکوردی برای نمایش وجود ندارد"
                          class="table table-secondary mb-4"
                        >
                          <template v-slot:head()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.label }}
                            </div>
                          </template>
                          <template v-slot:cell()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.value }}
                            </div>
                          </template>
                          <template v-slot:cell(index)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.index + 1 }}
                            </div>
                          </template>
                          <template v-slot:cell(expense)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ parseInt(data.value).toLocaleString() }}
                            </div>
                          </template>
                        </b-table>
                        <p>
                          جمع کل هزینه‌ها:
                          {{
                            old.expenses.length == 0
                              ? 0
                              : old.expenses
                                  .map((x) => parseInt(x.expense))
                                  .reduce(
                                    (a, b) => parseInt(a) + parseInt(b),
                                    0
                                  )
                                  .toLocaleString()
                          }}
                          ريال
                        </p>
                        <hr />
                        <h3>
                          بودجه درخواستی:
                          {{ old.budget.toLocaleString() }}
                          ریال
                        </h3>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-11 variant="dark">
                      <h5 class="mb-0" style="display: inline-block">تعهدات</h5>
                    </b-button>
                  </b-card-header>
                  <b-collapse
                    id="accordion-11"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text class="shadow p-3">
                        <b-form-group disabled>
                          <b-form-checkbox v-model="old.promiseArrays[0]">
                            <b
                              :class="
                                old.promiseArrays[0] ? 'done' : 'required'
                              "
                            >
                              اينجانب
                              {{
                                `"${old.assistantName} ${old.assistantLastName}" `
                              }}
                              رئیس دانشگاه
                              {{ `"${old.universityName}" ` }}
                              بدينوسيله مراتب فوق را تأييد می‌نمایم.</b
                            >
                          </b-form-checkbox>
                          <b-form-checkbox v-model="old.promiseArrays[1]">
                            <b
                              :class="
                                old.promiseArrays[1] ? 'done' : 'required'
                              "
                            >
                              اينجانب
                              {{
                                `"${old.managerName} ${old.managerLastName}" `
                              }}
                              راهبر طرح کلان دانشگاه
                              {{ `"${old.universityName}" ` }}
                              بدينوسيله مراتب فوق را تأييد می‌نمایم.
                            </b>
                          </b-form-checkbox>
                          <b-form-checkbox v-model="old.promiseArrays[2]"
                            ><b
                              :class="
                                old.promiseArrays[2] ? 'done' : 'required'
                              "
                            >
                              تكميل اين پروپوزال دليل بر تصويب طرح نمی‌باشد.
                            </b></b-form-checkbox
                          >
                          <b-form-checkbox v-model="old.promiseArrays[3]"
                            ><b
                              :class="
                                old.promiseArrays[3] ? 'done' : 'required'
                              "
                              >مجری پروژه صحت مندرجات اين پروپوزال را تأييد مي
                              نمايد.</b
                            ></b-form-checkbox
                          >
                        </b-form-group>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </b-tabs>
            </b-tab>
          </b-tabs>
        </b-tab>
        <b-tab v-if="role == 'admin'" title="تاریخچه">
          <!-- :text-variant="'white'" -->
          <b-card
            :bg-variant="computedVariant(index)"
            v-for="(p, index) in histories"
            :key="index"
            style="max-width: 80%"
            class="mb-3 border-0 shadow"
          >
            <template slot="header">
              <b-row>
                <b-col>
                  <h5>{{ p.name }}</h5>
                </b-col>
                <b-col>
                  <div style="float: left">
                    <h5>{{ p.date }}</h5>
                  </div>
                </b-col>
              </b-row>
            </template>

            <h6>{{ p.message }}</h6>
          </b-card>
        </b-tab>
        <b-tab v-if="role == 'admin'" title="مدیریت وضعیت">
          <b-form-group id="fieldset-1" label="وضعیت طرح">
            <b-form-group>
              <Select2
                v-model="decision"
                :options="situationsOptions"
                :settings="{ width: '75%' }"
              ></Select2>
            </b-form-group>
            <div v-if="decision == 2">
              <b-row>
                <i
                  class="fa fa-exclamation-triangle fa-2x text-warning ml-3"
                  aria-hidden="true"
                ></i>
                <p class="mt-2 ml-2 text-danger">
                  تذکر: لطفا توجه داشته باشد که متن نگارش شده توسط شما بدون
                  تغییر در اختیار کاربر قرار خواهد گرفت
                </p>
              </b-row>

              <b-form-textarea
                trim
                id="textarea"
                aria-describedby="adminMessage"
                v-model="adminMessage"
                width="75%"
                placeholder="نظرات خود را اینجا وارد نمایید"
                rows="8"
                max-rows="10"
              ></b-form-textarea>
              <b-form-invalid-feedback
                id="adminMessage"
                :state="adminMessage ? null : false"
                >با نوشتن نظر خود میتوانید دانشگاه را در انجام اصلاحات مورد نیاز
                راهنمایی کنید</b-form-invalid-feedback
              >
              <hr />
            </div>

            <b-form-group
              label="فایل قرارداد"
              class="my-3"
              :class="Object.keys(contractFileData).length ? 'done' : ''"
              v-else-if="decision == 4"
            >
              <b-form-file
                :state="Boolean(Object.keys(contractFileData).length)"
                :disabled="Boolean(Object.keys(contractFileData).length)"
                @input="finalLetterUploadFile(contractFile)"
                v-model="contractFile"
                browse-text="بارگذاری"
                :placeholder="
                  contractFileData
                    ? contractFileData.name
                    : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                "
              ></b-form-file>

              <b-col>
                <b-progress
                  v-if="contractFileData.showProgress"
                  :value="contractFileData.uploadPercentage"
                  :max="max"
                  show-progress
                  :animated="contractFileData.striped"
                  :variant="contractFileData.variant"
                ></b-progress>
                <br />
                <b-row>
                  <b-col>
                    <div
                      style="color: green"
                      v-if="contractFileData.isUploaded"
                      color="green"
                    >
                      فایل جدید با موفقیت آپلود شد.
                    </div>
                  </b-col>
                  <b-col>
                    <b-row
                      align-h="end"
                      v-if="Object.keys(contractFileData).length"
                    >
                      <span class="mt-3 ml-2" style="float: left"
                        ><a
                          class="btn btn-success white--text"
                          :href="contractFileData.url"
                          target="_blank"
                          >دریافت</a
                        ></span
                      >
                      <b-button
                        style="height: 35px; float: left"
                        class="btn ml-2 mt-3"
                        variant="danger"
                        @click="
                          contractFile = null;
                          contractFileData = {};
                        "
                        >حذف</b-button
                      >
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
              <b-form-textarea
                trim
                id="textarea"
                aria-describedby="adminMessage"
                v-model="adminMessage"
                width="75%"
                placeholder="راهنمایی تکمیل قرارداد را اینجا وارد نمایید"
                rows="8"
                max-rows="10"
              ></b-form-textarea>
              <b-form-invalid-feedback
                id="adminMessage"
                :state="adminMessage ? null : false"
                >با نوشتن راهنمایی های لازم، دانشگاه را در امر آماده سازی
                قرارداد راهنمایی بفرمایید.</b-form-invalid-feedback
              >
              <hr />
            </b-form-group>
            <b-form-group label="دلایل رد درخواست" v-else-if="decision == 6">
              <v-select
                multiple
                :reduce="(x) => x.code"
                :options="rejectOptions"
                v-model="rejectionIds"
              >
              </v-select>
            </b-form-group>
            <b-form-group label="یادداشت" class="mt-4">
              <b-form-textarea
                trim
                id="textarea"
                aria-describedby="description"
                v-model="description"
                width="75%"
                placeholder="نظرات خود را اینجا وارد نمایید"
                rows="8"
                max-rows="10"
              ></b-form-textarea>
            </b-form-group>
            <b-form-group>
              <b-button :disabled="disableSubmit" @click="submit()"
                >ثبت</b-button
              >
            </b-form-group>
          </b-form-group>
        </b-tab>
        <b-tab v-if="role == 'admin'" title="مدیریت RFP">
          <b-form-group>
            <b-button @click="addRfpField()" variant="success" class="mb-4"
              >افزودن</b-button
            >
            <b-table
              responsive
              small
              show-empty
              head-variant="dark"
              :items="rfps"
              :fields="rfpsField"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table table-secondary"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
              <template v-slot:cell(file)="data">
                <div style="display: flex; flex-direction: column; gap: 5px">
                  <b-form-file
                    :state="Boolean(Object.keys(rfpFileData).length)"
                    :disabled="Boolean(Object.keys(rfpFileData).length)"
                    @input="rfpUploadFile(rfpfile, data.index)"
                    v-model="rfpfile"
                    browse-text="بارگذاری"
                    :placeholder="
                      rfpFileData
                        ? rfpFileData.name
                        : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                    "
                  ></b-form-file>
                </div>
              </template>
              <template v-slot:cell(operation)="data">
                <div>
                  <b-button
                    variant="danger"
                    class="mr-2"
                    @click="delRfpField(rfps, data.index)"
                    >x</b-button
                  >
                </div>
                <div v-if="data.item.url">
                  <b-button
                    variant="info"
                    class="mr-2"
                    @click="copyToClipboard(data.item.url)"
                  >
                    کپی
                  </b-button>
                </div>
              </template>
              <template v-slot:cell(title)="data">
                <div>
                  <b-form-input
                    trim
                    v-model="data.item.title"
                    type="text"
                  ></b-form-input>
                </div>
              </template>
            </b-table>
          </b-form-group>
          <b-form-group>
            <b-button @click="submitRfps()">ثبت rfp</b-button>
          </b-form-group>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import moment from "moment-jalaali";
const sarmadGantt = () => import("../sarmadGantt");
import Select2 from "v-select2-component";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "Uni Request",
  props: ["role"],
  components: {
    datePicker: VuePersianDatetimePicker,
    Select2,
    sarmadGantt: sarmadGantt,
  },
  data() {
    return {
      moment: moment,
      oldData: [],
      expireDisable: false,
      rejectCause: [],
      rejectOptions: [],
      myshow: false,
      selectedMehvar: 0,
      show: false,
      rejectMessage: "",
      fileBusy: true,
      situationsOptions: [
        { id: 1, eng: "registered", text: "ثبت شده" },
        { id: 2, eng: "incomplete", text: "نیاز به تکمیل / اصلاح" },
        { id: 3, eng: "corrected", text: "اصلاح شده" },
        { id: 4, eng: "approve", text: "پذیرش اولیه" },
        { id: 5, eng: "finalAccept", text: "تایید نهایی" },
        { id: 6, eng: "rejected", text: "رد شده است" },
        { id: 7, eng: "declined", text: "لغو" },
      ],
      oldInfo: {},
      source: "",
      reviews: [],
      haveReferee: null,
      contract: null,
      zone: new Array(6).fill(false),
      prof: {},
      pageLoaded: false,
      fileFilter: "",
      reviewerData: [],
      isSaving: false,
      selectedReviewer: {},
      color: "",
      tabIndex: 0,
      isLoaded: true,
      removeLoading: false,
      //----------------- Uni Request------------------//
      universityName: "",
      status: "",
      adminMessage: "",
      initialObligation: false,
      faSubject: "",
      enSubject: "",
      catId: "",
      catName: "",
      cats: [],
      zoneMedicine: false,
      zoneAgriculture: false,
      zoneEnvironmentIndustrial: false,
      assistantName: "",
      assistantLastName: "",
      assistantNatcode: "",
      assistantMobile: "",
      managerName: "",
      managerLastName: "",
      managerMobile: "",
      managerNatcode: "",
      managerEmail: "",
      managerTel: "",
      managerAddress: "",
      managerCityId: "",
      managerStateId: "",
      managerJobCityId: "",
      managerJobStateId: "",
      managerStateName: "",
      managerCityName: "",
      managerJobStateName: "",
      managerJobCityName: "",
      managerJobTel: "",
      managerJobAddress: "",
      managerLastDegree: "",
      degreeOptions: [
        {
          value: "کارشناسی",
          text: "کارشناسی",
        },
        {
          value: "کارشناسی ارشد",
          text: "کارشناسی ارشد",
        },
        {
          value: "دکتری",
          text: "دکتری",
        },
      ],
      managerAbstract: "",
      scienceCommittee: [
        {
          name: "",
          position: "",
          degree: "",
          field: "",
          university: "",
          year: "",
        },
      ],
      scienceCommitteeField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام و نام خانوادگی" },
        { key: "position", label: "سمت" },
        { key: "degree", label: "آخرین مدرک تحصیلی" },
        { key: "field", label: "رشته تحصیلی" },
        { key: "university", label: "نام موسسه محل تحصیل" },
        { key: "year", label: "سال دریافت" },
        { key: "operation", label: "" },
      ],
      scienceCommitteeFieldDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام و نام خانوادگی" },
        { key: "position", label: "سمت" },
        { key: "degree", label: "آخرین مدرک تحصیلی" },
        { key: "field", label: "رشته تحصیلی" },
        { key: "university", label: "نام موسسه محل تحصیل" },
        { key: "year", label: "سال دریافت" },
      ],
      relatedHistories: [
        {
          title: "",
          boss: "",
          year: "",
          verification: false,
        },
      ],
      relatedHistoriesField: [
        { key: "index", label: "#" },
        { key: "title", label: "عنوان طرح" },
        { key: "boss", label: "کارفرما" },
        { key: "year", label: "سال اجرا" },
        { key: "verification", label: "وجود تاییدیه کارفرما" },
        { key: "operation", label: "" },
      ],
      relatedHistoriesFieldDoc: [
        { key: "index", label: "#" },
        { key: "title", label: "عنوان طرح" },
        { key: "boss", label: "کارفرما" },
        { key: "year", label: "سال اجرا" },
        { key: "verification", label: "وجود تاییدیه کارفرما" },
      ],
      managementAbstract: "",
      abstract: "",
      megaOutputs: [
        {
          title: "",
          quantity: "",
          time: "",
        },
      ],
      megaOutputsField: [
        { key: "index", label: "#" },
        { key: "title", label: "نام دستاورد" },
        { key: "quantity", label: "میزان کمی دستاوردها" },
        { key: "time", label: "پیش‌بینی زمان تحقق (ماه)" },
        { key: "operation", label: "" },
      ],
      megaOutputsFieldDoc: [
        { key: "index", label: "#" },
        { key: "title", label: "نام دستاورد" },
        { key: "quantity", label: "میزان کمی دستاوردها" },
        { key: "time", label: "پیش‌بینی زمان تحقق (ماه)" },
      ],
      minorDataField: [
        { key: "index", label: "#" },
        { key: "title", label: "عنوان" },
        { key: "results", label: "نام دستاورد" },
        { key: "quantity", label: "میزان کمی دستاوردها" },
        { key: "time", label: "پیش‌بینی زمان تحقق (ماه)" },
        { key: "budget", label: "بودجه پیشنهادی (میلیون ریال)" },
        { key: "operation", label: "" },
      ],
      minorDataFieldDoc: [
        { key: "index", label: "#" },
        { key: "title", label: "عنوان" },
        { key: "results", label: "نام دستاورد" },
        { key: "quantity", label: "میزان کمی دستاوردها" },
        { key: "time", label: "پیش‌بینی زمان تحقق (ماه)" },
        { key: "budget", label: "بودجه پیشنهادی (میلیون ریال)" },
      ],
      minorData1: [
        {
          title: "",
          results: "",
          quantity: "",
          time: "",
          budget: "",
        },
      ],
      minorData2: [
        {
          title: "",
          results: "",
          quantity: "",
          time: "",
          budget: "",
        },
      ],
      minorData3: [],
      minorData4: [],
      minorData5: [],
      minorData6: [],
      minorData7: [],
      minorData8: [],
      gantData: [],
      duration: "",
      startDate: "",
      finalDate: "",
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      serviceFieldsDoc: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
      ],
      budget: 0,
      expenses: [
        {
          title: "",
          step: "",
          expense: 0,
        },
      ],
      expensesFields: [
        { key: "index", label: "#" },
        { key: "title", label: "نوع هزینه" },
        { key: "step", label: "سطح میانی (بلوک)" },
        { key: "expense", label: "هزینه (ریال)" },
        { key: "operation", label: "" },
      ],
      expensesFieldsDoc: [
        { key: "index", label: "#" },
        { key: "title", label: "نوع هزینه" },
        { key: "step", label: "سطح میانی (بلوک)" },
        { key: "expense", label: "هزینه (ریال)" },
      ],
      promiseArrays: [false, false, false, false],
      revision: 0,
      requestsCode: "",
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
      registerDate: "",
      histories: [],
      decision: "",
      description: "",
      adminToReferee: "",
      rejectionIds: [],
      rejections: [],
      isArchive: false,
      archives: [],
      contractFile: [],
      contractFileData: {},
      rfps: [],
      rfpsField: [
        { key: "index", label: "#" },
        { key: "title", label: "عنوان" },
        { key: "file", label: "فایل" },
        { key: "operation", label: "عملیات" },
      ],
      rfpFileData: {},
      max: 100,
    };
  },

  methods: {
    viewList() {
      localStorage.setItem("list", "accelerator");
      let link = "/map";
      window.open(link, "_blank");
    },
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = this.requestsCode + ".doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },

    onMounted() {
      // NOTE (MOUNTED) to show the data of this page
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.$root.$emit("show::modal", "loading");

      this.busyAll = true;
      this.$http
        .post(
          this.baseUrl + "/setad/options/rejections",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.rejectOptions = res.data;
          this.rejectOptions.forEach((x) => {
            x.code = x.id;
            x.label = x.name;
          });
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
      if (this.role == "admin") {
        let acc = 0;
        this.$http
          .get(
            `${this.baseUrl}/setad/admin/uniRequest/${this.$route.params.id}`,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.histories = res.data.history;
            this.isArchive = res.data.isArchive ? res.data.isArchive : false;
            this.archives = res.data.archives ? res.data.archives : [];
            const unirequest = res.data.uniRequest;
            this.rfps = unirequest.rfps ? unirequest.rfps : [];
            this.adminMessage = unirequest.adminMessage
              ? unirequest.adminMessage
              : "";
            this.status = unirequest.status;
            this.rejectionIds = unirequest.rejectionIds
              ? unirequest.rejectionIds.map((x) => x._id)
              : [];
            this.rejections = unirequest.rejectionIds
              ? unirequest.rejectionIds.map((x) => x.name)
              : [];
            this.registerDate = unirequest.registerDate;
            this.universityName = unirequest.universityName;
            this.initialObligation = unirequest.initialObligation
              ? unirequest.initialObligation
              : false;
            this.faSubject = unirequest.faSubject;
            this.enSubject = unirequest.enSubject;
            this.catId = unirequest.catId;
            this.catName = unirequest.catName ? unirequest.catName : "";
            this.zoneMedicine = unirequest.zoneMedicine
              ? unirequest.zoneMedicine
              : false;
            this.zoneAgriculture = unirequest.zoneAgriculture
              ? unirequest.zoneAgriculture
              : false;
            this.zoneEnvironmentIndustrial =
              unirequest.zoneEnvironmentIndustrial
                ? unirequest.zoneEnvironmentIndustrial
                : false;
            //--------------------Assistant & Manager-------------------//
            this.assistantName = unirequest.assistantName
              ? unirequest.assistantName
              : "";
            this.assistantLastName = unirequest.assistantLastName
              ? unirequest.assistantLastName
              : "";
            this.assistantNatcode = unirequest.assistantNatcode
              ? unirequest.assistantNatcode
              : "";
            this.assistantMobile = unirequest.assistantMobile
              ? unirequest.assistantMobile
              : "";
            this.managerName = unirequest.managerName
              ? unirequest.managerName
              : "";
            this.managerLastName = unirequest.managerLastName
              ? unirequest.managerLastName
              : "";
            this.managerMobile = unirequest.managerMobile
              ? unirequest.managerMobile
              : "";
            this.managerNatcode = unirequest.managerNatcode
              ? unirequest.managerNatcode
              : "";
            this.managerEmail = unirequest.managerEmail
              ? unirequest.managerEmail
              : "";
            this.managerTel = unirequest.managerTel
              ? unirequest.managerTel
              : "";
            this.managerAddress = unirequest.managerAddress
              ? unirequest.managerAddress
              : "";
            this.managerCityId = unirequest.managerCityId
              ? unirequest.managerCityId
              : "";
            this.managerStateId = unirequest.managerStateId
              ? unirequest.managerStateId
              : "";
            this.managerJobCityId = unirequest.managerJobCityId
              ? unirequest.managerJobCityId
              : "";
            this.managerJobStateId = unirequest.managerJobStateId
              ? unirequest.managerJobStateId
              : "";
            this.managerStateName = unirequest.managerStateName;
            this.managerCityName = unirequest.managerCityName;
            this.managerJobStateName = unirequest.managerJobStateName;
            this.managerJobCityName = unirequest.managerJobCityName;
            this.managerJobTel = unirequest.managerJobTel
              ? unirequest.managerJobTel
              : "";
            this.managerJobAddress = unirequest.managerJobAddress
              ? unirequest.managerJobAddress
              : "";
            this.managerLastDegree = unirequest.managerLastDegree
              ? unirequest.managerLastDegree
              : "";
            this.managerAbstract = unirequest.managerAbstract
              ? unirequest.managerAbstract
              : "";
            this.scienceCommittee = unirequest.scienceCommittee
              ? unirequest.scienceCommittee.length
                ? unirequest.scienceCommittee
                : [
                    {
                      name: "",
                      position: "",
                      degree: "",
                      field: "",
                      university: "",
                      year: "",
                    },
                  ]
              : [
                  {
                    name: "",
                    position: "",
                    degree: "",
                    field: "",
                    university: "",
                    year: "",
                  },
                ];
            this.relatedHistories = unirequest.relatedHistories
              ? unirequest.relatedHistories.length
                ? unirequest.relatedHistories
                : [
                    {
                      title: "",
                      boss: "",
                      year: "",
                      verification: false,
                    },
                  ]
              : [
                  {
                    title: "",
                    boss: "",
                    year: "",
                    verification: false,
                  },
                ];
            this.managementAbstract = unirequest.managementAbstract
              ? unirequest.managementAbstract
              : "";
            this.abstract = unirequest.abstract ? unirequest.abstract : "";
            this.megaOutputs = unirequest.megaOutputs
              ? unirequest.megaOutputs.length
                ? unirequest.megaOutputs
                : [
                    {
                      title: "",
                      quantity: "",
                      time: "",
                    },
                  ]
              : [
                  {
                    title: "",
                    quan: "",
                    time: "",
                  },
                ];
            this.minorData1 = unirequest.minorData1
              ? unirequest.minorData1.length
                ? unirequest.minorData1
                : [
                    {
                      title: "",
                      results: "",
                      quantity: "",
                      time: "",
                      budget: "",
                    },
                  ]
              : [
                  {
                    title: "",
                    results: "",
                    quantity: "",
                    time: "",
                    budget: "",
                  },
                ];
            this.minorData2 = unirequest.minorData2
              ? unirequest.minorData2.length
                ? unirequest.minorData2
                : [
                    {
                      title: "",
                      results: "",
                      quantity: "",
                      time: "",
                      budget: "",
                    },
                  ]
              : [
                  {
                    title: "",
                    results: "",
                    quantity: "",
                    time: "",
                    budget: "",
                  },
                ];
            this.minorData3 = unirequest.minorData3
              ? unirequest.minorData3.length
                ? unirequest.minorData3
                : []
              : [];
            this.minorData4 = unirequest.minorData4
              ? unirequest.minorData4.length
                ? unirequest.minorData4
                : []
              : [];
            this.minorData5 = unirequest.minorData5
              ? unirequest.minorData5.length
                ? unirequest.minorData5
                : []
              : [];
            this.minorData6 = unirequest.minorData6
              ? unirequest.minorData6.length
                ? unirequest.minorData6
                : []
              : [];
            this.minorData7 = unirequest.minorData7
              ? unirequest.minorData7.length
                ? unirequest.minorData7
                : []
              : [];
            this.minorData8 = unirequest.minorData8
              ? unirequest.minorData8.length
                ? unirequest.minorData8
                : []
              : [];
            this.gantData = unirequest.gantData
              ? unirequest.gantData.length
                ? unirequest.gantData
                : []
              : [];
            this.duration = unirequest.duration ? unirequest.duration : "";
            this.startDate = unirequest.startDate ? unirequest.startDate : "";
            this.finalDate = unirequest.finalDate ? unirequest.finalDate : "";
            this.budget = unirequest.budget ? unirequest.budget : 0;
            this.expenses = unirequest.expenses
              ? unirequest.expenses.length
                ? unirequest.expenses
                : [
                    {
                      title: "",
                      step: "",
                      expense: 0,
                    },
                  ]
              : [
                  {
                    title: "",
                    step: "",
                    expense: 0,
                  },
                ];

            this.promiseArrays = unirequest.promiseArrays
              ? unirequest.promiseArrays
              : [false, false, false, false];
            this.revision = unirequest.revision ? unirequest.revision : 0;
            this.requestsCode = unirequest.requestsCode
              ? unirequest.requestsCode
              : "";
            this.contractFileData = unirequest.finalContractFileId
              ? {
                  id: unirequest.finalContractFileId,
                  name: unirequest.finalContractFileName,
                  url: unirequest.finalContractFileUrl,
                }
              : {};
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
              this.$bvModal.hide("loading");
              this.isLoaded = true;
              this.pageLoaded = true;
              this.show = true;
            }, 200);
            acc++;
            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch (err) {
                console.log(err);
              }
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else if (this.role == "university") {
        this.$http
          .get(
            `${this.baseUrl}/setad/university/uniRequest/${this.$route.params.id}`,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            const unirequest = res.data;
            this.adminMessage = unirequest.adminMessage
              ? unirequest.adminMessage
              : "";
            this.status = unirequest.status;
            this.adminToReferee = unirequest.adminToReferee
              ? unirequest.adminToReferee
              : "";
            this.rejectionIds = unirequest.rejectionIds
              ? unirequest.rejectionIds.map((x) => x._id)
              : [];
            this.rejections = unirequest.rejectionIds
              ? unirequest.rejectionIds.map((x) => x.name)
              : [];
            this.registerDate = unirequest.registerDate;
            this.universityName = unirequest.universityName;
            this.initialObligation = unirequest.initialObligation
              ? unirequest.initialObligation
              : false;
            this.faSubject = unirequest.faSubject;
            this.enSubject = unirequest.enSubject;
            this.catId = unirequest.catId;
            this.catName = unirequest.catName ? unirequest.catName : "";
            this.zoneMedicine = unirequest.zoneMedicine
              ? unirequest.zoneMedicine
              : false;
            this.zoneAgriculture = unirequest.zoneAgriculture
              ? unirequest.zoneAgriculture
              : false;
            this.zoneEnvironmentIndustrial =
              unirequest.zoneEnvironmentIndustrial
                ? unirequest.zoneEnvironmentIndustrial
                : false;
            //--------------------Assistant & Manager-------------------//
            this.assistantName = unirequest.assistantName
              ? unirequest.assistantName
              : "";
            this.assistantLastName = unirequest.assistantLastName
              ? unirequest.assistantLastName
              : "";
            this.assistantNatcode = unirequest.assistantNatcode
              ? unirequest.assistantNatcode
              : "";
            this.assistantMobile = unirequest.assistantMobile
              ? unirequest.assistantMobile
              : "";
            this.managerName = unirequest.managerName
              ? unirequest.managerName
              : "";
            this.managerLastName = unirequest.managerLastName
              ? unirequest.managerLastName
              : "";
            this.managerMobile = unirequest.managerMobile
              ? unirequest.managerMobile
              : "";
            this.managerNatcode = unirequest.managerNatcode
              ? unirequest.managerNatcode
              : "";
            this.managerEmail = unirequest.managerEmail
              ? unirequest.managerEmail
              : "";
            this.managerTel = unirequest.managerTel
              ? unirequest.managerTel
              : "";
            this.managerAddress = unirequest.managerAddress
              ? unirequest.managerAddress
              : "";
            this.managerCityId = unirequest.managerCityId
              ? unirequest.managerCityId
              : "";
            this.managerStateId = unirequest.managerStateId
              ? unirequest.managerStateId
              : "";
            this.managerJobCityId = unirequest.managerJobCityId
              ? unirequest.managerJobCityId
              : "";
            this.managerJobStateId = unirequest.managerJobStateId
              ? unirequest.managerJobStateId
              : "";
            this.managerStateName = unirequest.managerStateName;
            this.managerCityName = unirequest.managerCityName;
            this.managerJobStateName = unirequest.managerJobStateName;
            this.managerJobCityName = unirequest.managerJobCityName;
            this.managerJobTel = unirequest.managerJobTel
              ? unirequest.managerJobTel
              : "";
            this.managerJobAddress = unirequest.managerJobAddress
              ? unirequest.managerJobAddress
              : "";
            this.managerLastDegree = unirequest.managerLastDegree
              ? unirequest.managerLastDegree
              : "";
            this.managerAbstract = unirequest.managerAbstract
              ? unirequest.managerAbstract
              : "";
            this.scienceCommittee = unirequest.scienceCommittee
              ? unirequest.scienceCommittee.length
                ? unirequest.scienceCommittee
                : [
                    {
                      name: "",
                      position: "",
                      degree: "",
                      field: "",
                      university: "",
                      year: "",
                    },
                  ]
              : [
                  {
                    name: "",
                    position: "",
                    degree: "",
                    field: "",
                    university: "",
                    year: "",
                  },
                ];
            this.relatedHistories = unirequest.relatedHistories
              ? unirequest.relatedHistories.length
                ? unirequest.relatedHistories
                : [
                    {
                      title: "",
                      boss: "",
                      year: "",
                      verification: false,
                    },
                  ]
              : [
                  {
                    title: "",
                    boss: "",
                    year: "",
                    verification: false,
                  },
                ];
            this.managementAbstract = unirequest.managementAbstract
              ? unirequest.managementAbstract
              : "";
            this.abstract = unirequest.abstract ? unirequest.abstract : "";
            this.megaOutputs = unirequest.megaOutputs
              ? unirequest.megaOutputs.length
                ? unirequest.megaOutputs
                : [
                    {
                      title: "",
                      quantity: "",
                      time: "",
                    },
                  ]
              : [
                  {
                    title: "",
                    quan: "",
                    time: "",
                  },
                ];
            this.minorData1 = unirequest.minorData1
              ? unirequest.minorData1.length
                ? unirequest.minorData1
                : [
                    {
                      title: "",
                      results: "",
                      quantity: "",
                      time: "",
                      budget: "",
                    },
                  ]
              : [
                  {
                    title: "",
                    results: "",
                    quantity: "",
                    time: "",
                    budget: "",
                  },
                ];
            this.minorData2 = unirequest.minorData2
              ? unirequest.minorData2.length
                ? unirequest.minorData2
                : [
                    {
                      title: "",
                      results: "",
                      quantity: "",
                      time: "",
                      budget: "",
                    },
                  ]
              : [
                  {
                    title: "",
                    results: "",
                    quantity: "",
                    time: "",
                    budget: "",
                  },
                ];
            this.minorData3 = unirequest.minorData3
              ? unirequest.minorData3.length
                ? unirequest.minorData3
                : []
              : [];
            this.minorData4 = unirequest.minorData4
              ? unirequest.minorData4.length
                ? unirequest.minorData4
                : []
              : [];
            this.minorData5 = unirequest.minorData5
              ? unirequest.minorData5.length
                ? unirequest.minorData5
                : []
              : [];
            this.minorData6 = unirequest.minorData6
              ? unirequest.minorData6.length
                ? unirequest.minorData6
                : []
              : [];
            this.minorData7 = unirequest.minorData7
              ? unirequest.minorData7.length
                ? unirequest.minorData7
                : []
              : [];
            this.minorData8 = unirequest.minorData8
              ? unirequest.minorData8.length
                ? unirequest.minorData8
                : []
              : [];
            this.gantData = unirequest.gantData
              ? unirequest.gantData.length
                ? unirequest.gantData
                : []
              : [];
            this.duration = unirequest.duration ? unirequest.duration : "";
            this.startDate = unirequest.startDate ? unirequest.startDate : "";
            this.finalDate = unirequest.finalDate ? unirequest.finalDate : "";
            this.budget = unirequest.budget ? unirequest.budget : 0;
            this.expenses = unirequest.expenses
              ? unirequest.expenses.length
                ? unirequest.expenses
                : [
                    {
                      title: "",
                      step: "",
                      expense: 0,
                    },
                  ]
              : [
                  {
                    title: "",
                    step: "",
                    expense: 0,
                  },
                ];

            this.promiseArrays = unirequest.promiseArrays
              ? unirequest.promiseArrays
              : [false, false, false, false];
            this.revision = unirequest.revision ? unirequest.revision : 0;
            this.requestsCode = unirequest.requestsCode
              ? unirequest.requestsCode
              : "";
            this.contractFileData = unirequest.finalContractFileId
              ? {
                  id: unirequest.finalContractFileId,
                  name: unirequest.finalContractFileName,
                  url: unirequest.finalContractFileUrl,
                }
              : {};
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch (err) {
              console.log(err);
            }
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            setTimeout(() => {
              this.show = true;
              this.pageLoaded = true;
            }, 200);

            this.fileBusy = false;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
      }

      this.fileBusy = false;
    },
    hideModal(type) {
      // NOTE (m-hideModal) to hide loading
      this.$refs[type].hide();
    },
    computedVariant(seed) {
      // REVIEW
      let variant = [
        "primary",
        "secondary",
        "success",
        "warning",
        "danger",
        "dark",
        "info",
        "light",
      ];
      return variant[seed % 8];
    },
    submit() {
      this.$bvModal.show("loading");
      const status = this.situationsOptions.filter(
        (x) => x.id == this.decision
      )[0].eng;
      if (status != "rejected") this.rejectionIds = [];
      this.$http
        .patch(
          `${this.baseUrl}/setad/admin/uniRequest/decision/${this.$route.params.id}`,
          {
            status: status,
            adminMessage:
              this.decision == 2 || this.decision == 4
                ? this.adminMessage
                : undefined,
            description: this.description,
            rejectionIds: this.rejectionIds,
            finalContractFileId:
              this.decision == 4
                ? this.contractFileData
                  ? this.contractFileData.id
                  : undefined
                : undefined,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        ) // REVIEW
        .then((res) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          if (res.status == 200) {
            this.description = "";
            this.adminToReferee = "";
            this.toast(res.data, "success");
            window.location.reload();
          }
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    submitRfps() {
      this.$bvModal.show("loading");
      this.$http
        .patch(
          `${this.baseUrl}/setad/admin/uniRequest/rfps/${this.$route.params.id}`,
          {
            rfps: this.rfps,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        ) // REVIEW
        .then((res) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          if (res.status == 200) {
            this.toast(res.data, "success");
            window.location.reload();
          }
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    addRfpField() {
      this.rfps.push({
        title: "",
        fileId: null,
        url: "",
      });
    },
    delRfpField(list, index) {
      list.splice(index, 1);
    },
    copyToClipboard(text, index) {
      navigator.clipboard.writeText(text);
    },
    rfpUploadFile(file, index) {
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.rfpFileData.showProgress = true;
        this.rfpFileData.variant = "info";
        this.rfpFileData.uploadPercentage = 0;
        this.rfpFileData.isUploaded = false;
        this.rfpFileData.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl +
              "/setad/admin/uniRequest/upload/" +
              this.$route.params.id,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.rfpFileData.uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.rfpFileData.isUploaded = true;
              this.rfpFileData.uploadPercentage = 100;
              this.rfpFileData.striped = false;
              this.rfpFileData.variant = "success";
              this.rfpFileData.uploadButDisable = false;
              this.rfpFileData = d.data;
              this.rfps[index].fileId = this.rfpFileData.id;
              this.rfps[index].url = this.rfpFileData.url;
              this.$forceUpdate();
              this.toast("فایل با موفقیت بارگذاری کردید.", "success");
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.contractFile = null;
            this.rfpFileData.uploadPercentage = 0;
            this.rfpFileData.isUploaded = false;
          });
      }
    },
    finalLetterUploadFile(file) {
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.contractFileData.showProgress = true;
        this.contractFileData.variant = "info";
        this.contractFileData.uploadPercentage = 0;
        this.contractFileData.isUploaded = false;
        this.contractFileData.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl +
              "/setad/admin/uniRequest/upload/" +
              this.$route.params.id,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.contractFileData.uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.contractFileData.isUploaded = true;
              this.contractFileData.uploadPercentage = 100;
              this.contractFileData.striped = false;
              this.contractFileData.variant = "success";
              this.contractFileData.uploadButDisable = false;
              this.contractFileData = d.data;
              this.$forceUpdate();
              this.toast("فایل با موفقیت بارگذاری کردید.", "success");
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.contractFile = null;
            this.contractFileData.uploadPercentage = 0;
            this.contractFileData.isUploaded = false;
          });
      }
    },
  },
  computed: {
    disableSubmit() {
      if (this.decision) {
        if (this.decision == 2) {
          if (!this.adminMessage) return true;
          else return false;
        }
        if (this.decision == 4) {
          if (!Object.keys(this.contractFileData).length) return true;
          else return false;
        }
        if (this.decision == 6 && !this.rejectionIds.length) return true;
        return false;
      } else return true;
    },
  },
  mounted() {
    this.onMounted();
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
  },
};
</script>
<style lang="scss">
.selected-referees {
  border: 1px solid grey;
  border-radius: 5px;
  margin-bottom: 10px;
  &__tags {
    border: 1px solid grey;
    border-radius: 5px;
    padding: 8px 12px;
    .tag {
      padding: 5px;
      margin: 5px;
    }
  }
}
</style>
<style lang="scss" scoped>
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.select2 {
  width: 100% !important;
}

select {
  min-width: max-content;
  width: 100%;
}

.required {
  color: red;
}

.done {
  color: green;
}
.btn-dark {
  h5 {
    color: #fff !important;
  }
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  h5 {
    color: #fff !important;
  }
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  h5 {
    color: #fff !important;
  }
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  h5 {
    color: #fff !important;
  }
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  h5 {
    color: #fff !important;
  }
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}

#vs1__listbox {
  text-align: right;
  direction: rtl;
}
</style>
<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
</style>
